// extracted by mini-css-extract-plugin
export default {"wrapper":"AboutPage_wrapper__cW9dz","title":"AboutPage_title__ntRTz","subtitle":"AboutPage_subtitle__JSQza","list":"AboutPage_list__2ntpJ"};